<template>
  <div class="relative">
    <div class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-pink-200">
      <div
        :style="{ width: percent + '%' }"
        class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-pink-500"
      ></div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'

export default {
  name: 'JGProgressbar',
  props: {
    delay: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      percent: 0,
    }
  },
  methods: {
    start() {
      const tick = _.ceil(_.divide(this.delay, 100), 0)
      const interval = setInterval(() => {
        if (this.percent >= 100) {
          clearInterval(interval)
          return
        }
        this.percent += 1
      }, tick)
    },
  },
}
</script>
